module.exports = __webpack_public_path__ + "img/INYO_COVER.0b863ca8.png";